import { Mail, LogOut, User, BarChart3 } from 'lucide-react';
import { CreditDisplay } from '../billing/CreditDisplay';
import { useUser } from '../../contexts/UserContext';
import { useAuthContext } from '../../contexts/AuthContext';
import { useAnalysisContext } from '../../contexts/AnalysisContext';

export function Header({
  swingHistory,
  showDashboard,
  fetchDashboard,
  setShowDashboard,
}) {
  const { isAuthenticated, userEmail, logout } = useUser();
  const { openAuthModal } = useAuthContext();
  const { analysisResult, resetAnalysis } = useAnalysisContext();

  return (
    <header className="border-b border-white/10 backdrop-blur-xl sticky top-0 z-50 bg-black/50">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 sm:px-6 py-3 sm:py-5">
        <button
          onClick={() => {
            resetAnalysis();
            setShowDashboard(false);
          }}
          className="flex items-center gap-2 sm:gap-3 hover:opacity-80 transition"
        >
          <img
            src="/logo-bird.png"
            alt="SwingSlot"
            className="h-8 w-8 sm:h-9 sm:w-9 rounded-lg flex-shrink-0"
          />
          <span className="text-base sm:text-xl font-bold">SwingSlot</span>
        </button>
        <div className="flex items-center gap-2 sm:gap-4">
          <CreditDisplay />

          {/* Auth Status */}
          {isAuthenticated ? (
            <div className="flex items-center gap-2">
              <div className="hidden sm:flex items-center gap-2 text-sm text-slate-400">
                <User className="h-4 w-4" />
                <span className="max-w-[120px] truncate">{userEmail}</span>
              </div>
              <button
                onClick={logout}
                className="text-sm font-medium text-slate-400 hover:text-red-400 transition flex items-center gap-1 p-2 -m-2 min-h-[44px] min-w-[44px] justify-center"
                title="Sign out"
                aria-label="Sign out"
              >
                <LogOut className="h-5 w-5 sm:h-4 sm:w-4" />
                <span className="hidden sm:inline">Sign out</span>
              </button>
            </div>
          ) : (
            <button
              onClick={openAuthModal}
              className="text-sm font-medium text-slate-400 hover:text-emerald-400 transition flex items-center gap-1 p-2 -m-2 min-h-[44px] min-w-[44px] justify-center"
              aria-label="Sign in"
            >
              <Mail className="h-5 w-5 sm:h-4 sm:w-4" />
              <span className="hidden sm:inline">Sign in</span>
            </button>
          )}

          {/* Dashboard button - always available when user has history */}
          {swingHistory.length > 0 && !showDashboard && (
            <button
              onClick={() => {
                resetAnalysis();
                fetchDashboard();
                setShowDashboard(true);
              }}
              className="text-sm font-medium text-slate-400 hover:text-emerald-400 flex items-center gap-1 p-2 -m-2 min-h-[44px] min-w-[44px] justify-center"
              aria-label="Dashboard"
            >
              <BarChart3 className="h-5 w-5 sm:h-4 sm:w-4" />
              <span className="hidden sm:inline">Dashboard</span>
            </button>
          )}

          {/* New lesson button when viewing analysis or dashboard */}
          {(analysisResult || showDashboard) && (
            <button
              onClick={() => {
                resetAnalysis();
                setShowDashboard(false);
              }}
              className="rounded-lg bg-gradient-to-r from-emerald-500 to-green-500 px-2 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-bold text-black hover:scale-105 transition whitespace-nowrap"
            >
              New
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
